var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 5h7.795c1.115 0 1.519.116 1.926.334s.727.538.945.945S19 7.09 19 8.205V16a1 1 0 1 0 2 0V8.128c0-1.783-.186-2.43-.534-3.082a3.64 3.64 0 0 0-1.512-1.512C18.302 3.186 17.655 3 15.872 3H8a1 1 0 0 0 0 2m7.721 2.334C15.314 7.116 14.91 7 13.795 7h-7.59c-1.115 0-1.519.116-1.926.334a2.27 2.27 0 0 0-.945.945C3.116 8.686 3 9.09 3 10.205v7.59c0 1.114.116 1.519.334 1.926s.538.727.945.945S5.09 21 6.205 21h7.59c1.114 0 1.519-.116 1.926-.334s.727-.538.945-.945.334-.811.334-1.926v-7.59c0-1.115-.116-1.519-.334-1.926a2.27 2.27 0 0 0-.945-.945",
    clipRule: "evenodd"
  })));
};
export default SvgCopy;